export const itineraryPathSelector = ({itineraryPath}) => itineraryPath